export default function youTubeVideo() {
  return {
    _id: false,
    type: 'droplet.youTubeVideo',
    youTubeLink: false,
    height: 315,
    width: 420,
    autoplay: false,
    mediaQueries: [
      {
        global: true,
        selector: '.drzYouTubeVideo',
        properties: [
          {
            property: 'width',
            desktop: '420px',
            tablet: 'default',
            mobile: 'default',
          },
          {
            property: 'height',
            desktop: '315px',
            tablet: 'default',
            mobile: 'default',
          },
        ],
      },
    ],
    pageCSS: '',
    firstDrop: true,
    bounceDroplet: false,
    isShared: false,
    templateRegion: false,
  };
}



// WEBPACK FOOTER //
// ./src/global-view/editor/droplets/youtube-video/droplet.schema.js